module.exports = __webpack_public_path__ + "static/img/轮播_2.77290758.jpg";